import { environmentConfigAdapter } from '../adapters'
import { EnvironmentConfig } from '../model/environment-config'
export type { EnvironmentConfig } from '../model/environment-config'
export type { Stage } from '../model/stage'

export const environmentConfig: EnvironmentConfig = environmentConfigAdapter()
